import { TokenData } from '@typings/common';

const TOKEN_KEY = 'token';

export const getTokenData = () => {
    try {
        return JSON.parse(sessionStorage.getItem(TOKEN_KEY) ?? '') as TokenData;
    } catch (error) {
        return null;
    }
};
